import React, { useState } from 'react';

import { Input, Label } from '@iwoca/orion';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import styles from './ChooseSweepAmount.module.css';
import { convertSweepToDecimal } from '../../../myOffers/approvedView/offerConfigurationView/RBLOfferConfigurationView/RBLOfferConfiguration.helpers';
import { Rate } from '../../../ui/rate';
import { Slider } from '../Slider';

type TChooseSweepAmountProps = {
    className?: string;
    sweep: number;
    label?: { id: string; defaultMessage: string };
    tooltip?: React.ReactNode;
    absSweepMin?: number;
    absSweepMax?: number;
    sweepMin: number;
    sweepMax: number;
    updateSweepValue: (sweep: number) => void;
};

export const ChooseSweepAmount = ({
    className,
    sweep,
    label,
    tooltip,
    sweepMax,
    sweepMin,
    updateSweepValue
}: TChooseSweepAmountProps) => {
    const [sliderAmount, setSliderAmount] = useState(sweep);

    return (
        <div className={classNames(styles.amountSelect, className)}>
            <div className={styles.input}>
                {label && (
                    <>
                        <Label
                            className={styles.label}
                            htmlFor="sweep-amount-input"
                        >
                            <FormattedMessage
                                {...label}
                                values={{
                                    input: (
                                        <Input
                                            wrapperClassName={
                                                styles.inputWrapper
                                            }
                                            className={classNames(
                                                styles.sweepInput
                                            )}
                                            value={sliderAmount}
                                            onChange={(event) => {
                                                const value =
                                                    event.target.value;

                                                setSliderAmount(
                                                    parseFloat(value)
                                                );
                                            }}
                                            onBlur={() => {
                                                if (sliderAmount < sweepMin) {
                                                    setSliderAmount(sweepMin);
                                                }

                                                if (sliderAmount > sweepMax) {
                                                    setSliderAmount(sweepMax);
                                                }
                                                updateSweepValue(sliderAmount);
                                            }}
                                            type="text"
                                            step={0.01}
                                            id="sweep-amount-input"
                                        />
                                    )
                                }}
                            />
                        </Label>
                        {tooltip}
                    </>
                )}
            </div>

            <div className="w-full">
                <Slider
                    minValueLabel={
                        <div data-testid="minimum-sweep-amount">
                            <Rate value={convertSweepToDecimal(sweepMin)} />
                        </div>
                    }
                    maxValueLabel={
                        <div
                            data-testid="maximum-sweep-amount"
                            className={styles.sliderMax}
                        >
                            <Rate value={convertSweepToDecimal(sweepMax)} />
                        </div>
                    }
                    id="sweep-amount-slider"
                    name="sweep-amount-slider"
                    sliderMax={sweepMax}
                    sliderMin={sweepMin}
                    value={sliderAmount}
                    handleChange={(value) => setSliderAmount(parseFloat(value))}
                    step={0.01}
                    onAfterChange={() => {
                        updateSweepValue(sliderAmount);
                    }}
                    data-action-name="Sweep Amount slider"
                />
            </div>
        </div>
    );
};
